import React from 'react'

import { NOTIFICATION_TYPE } from './notification.types'

type TNotificationImagePlaceholder = {
  nameInitial?: string
  type?: string
}

const SRC_DETAIL_IMAGE = 'assets/images/notifications/information_icon_embroidery.svg'
const SRC_DEFAULT_PLACEHOLDER = 'assets/images/notifications/information_icon.svg'
const SRC_PASS_THROUGH = 'assets/images/notifications/pass-through.svg'

const NotificationImagePlaceholder = ({ nameInitial, type = '' }: TNotificationImagePlaceholder) => {
  if (nameInitial) {
    return (
      <div className="_text-purple-darker _bg-purple-light header-notification__thumb">
        {nameInitial}
        <img src={SRC_DETAIL_IMAGE} alt="" className="header-notification__detail_info" />
      </div>
    )
  }
  if (type === NOTIFICATION_TYPE.PRODUCT_ACTIVATION_AND_ENGAGEMENT) {
    return <img src={SRC_PASS_THROUGH} alt="" width={48} height={48} />
  }
  return <img src={SRC_DEFAULT_PLACEHOLDER} alt="" width={48} height={48} />
}

export default NotificationImagePlaceholder
